import { Components } from '@/common/fragment/components';

// Code the search results column needs before it can replace its loading skeleton: the Plasmic
// results list (Fragment `SearchResults`) and the consult banner above it. Both are lazy, so on a
// client navigation from another page (home → /s/…) the column dropped to nothing between the
// skeleton and the cards — the SEO box and footer jumped into view and out again (CLS ≈ 0.77 on
// mobile, docs/performance.md §۳.۲۱). Preloading through the registry also lets the list render in
// the same commit as its data instead of one painted frame later (see fragment/preloadable.tsx).
let ready = false;
let pending: Promise<void> | null = null;

export const isResultsCodeReady = () => ready;

export const loadResultsCode = () =>
  (pending ??= Promise.all([Components.SearchResults.preload?.(), import('@/modules/search/components/consultBanner')]).then(
    () => {
      ready = true;
    },
    () => {
      // Let the list render (and fail or retry through its own dynamic()) rather than hold the skeleton forever.
      pending = null;
    },
  ));
